<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="产品规格表" prop="goodSpecId" >
        <a-input v-model="form.goodSpecId" placeholder="请输入产品规格表" />
      </a-form-model-item>
      <a-form-model-item label="是否组合：0-否 1-是" prop="isCombination" >
        <a-input v-model="form.isCombination" placeholder="请输入是否组合：0-否 1-是" />
      </a-form-model-item>
      <a-form-model-item label="规格选项ID" prop="specOptionId" >
        <a-input v-model="form.specOptionId" placeholder="请输入规格选项ID" />
      </a-form-model-item>
      <a-form-model-item label="组合选项list,id,拼接" prop="specOptionsList" >
        <a-input v-model="form.specOptionsList" placeholder="请输入组合选项list,id,拼接" />
      </a-form-model-item>
      <a-form-model-item label="默认选项值" prop="defaultOption" >
        <a-input v-model="form.defaultOption" placeholder="请输入默认选项值" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSpecCombination, addSpecCombination, updateSpecCombination } from '@/api/user/specCombination'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        goodSpecId: null,

        isCombination: null,

        specOptionId: null,

        specOptionsList: null,

        defaultOption: null,

        sort: null,

        status: 1,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        goodSpecId: null,
        isCombination: null,
        specOptionId: null,
        specOptionsList: null,
        defaultOption: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null,
      }
                                  },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSpecCombination({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSpecCombination(this.form).then(response => {

              if(response.success) {
                this.$message.success('修改成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '修改失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSpecCombination(this.form).then(response => {
              if(response.success) {
                this.$message.success('新增成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '新增失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
